import ApiService from "./ApiService"

export default {
    get(id) {
            return ApiService().get(`api/locations/${id}`);
        },
        search(search) {
            let params = new URLSearchParams();
            if(search.output)
                params.append('output', search.output);
            if(search.search && search.search.length > 0)
                params.append('term', search.search);
            if(search.companyId && search.companyId > 0)
                params.append('companyId', search.companyId);
    
            let qs = params.toString();
            if(qs && qs.length > 0)
                qs = "?" + qs;
            return ApiService().get(`api/locations/${search.offset}/${search.limit}${qs}`);
        },
        post(body) {
            return ApiService().post(`api/locations`, body);
        },
        put(id, body) {
            return ApiService().put(`api/locations/${id}`, body);
        },
        delete(id) {
            return ApiService().delete(`api/locations/${id}`, {});
        }
}